import React from "react";
import { Box } from "@chakra-ui/react";
import ReactSelect from "react-select";

const searchableSelectStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "white",
    borderColor: state.isFocused ? "#3182CE" : "#CBD5E0",
    boxShadow: state.isFocused
      ? "0 0 0 1px #3182CE"
      : "0 1px 2px rgba(0,0,0,0.05)",
    minHeight: "40px",
    "&:hover": { borderColor: "#CBD5E0" },
  }),
  menu: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#2D3748"
      : state.isFocused
        ? "#EDF2F7"
        : "white",
    color: state.isSelected ? "white" : "#2D3748",
    cursor: "pointer",
  }),
  placeholder: (base) => ({ ...base, color: "#A0AEC0" }),
  singleValue: (base) => ({ ...base, color: "#2D3748" }),
};

/**
 * A searchable store dropdown built on react-select.
 *
 * Props:
 *   options      – array of { value, label }
 *   value        – currently selected value string
 *   onChange     – called with the selected value string (or "" when cleared)
 *   isDisabled   – whether the control is disabled
 *   placeholder  – placeholder text
 */
const SearchableStoreSelect = ({
  options,
  value,
  onChange,
  isDisabled,
  placeholder,
}) => {
  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <Box minW="200px">
      <ReactSelect
        options={options}
        value={selectedOption}
        onChange={(opt) => onChange(opt ? opt.value : "")}
        isDisabled={isDisabled}
        placeholder={placeholder || "Select Branch"}
        isSearchable
        isClearable={false}
        styles={searchableSelectStyles}
      />
    </Box>
  );
};

export default SearchableStoreSelect;
